export const appPagePaths = {
  root: "/",
  home: "/",
  annotation: "/annotation",
  video: "/video",
  theory: "/theory/:id",
  target: "/target",
  interactive: "/interactive/:id",
  test: "/test",
  literature: "/literature",
  methodologicalModule: "/methodological_module/:id",
  practicalModule: "/practical_module/:id",
  additionalMaterials: "/additional_materials"
};

export const appRouterPaths = {
  root: "/",
  home: "/",
  annotation: "/annotation",
  literature: "/literature",
  video: "/video",
  theory: "/theory/:id",
  target: "/target",
  interactive: "/interactive/:id",
  test: "/test",
  methodologicalModule: "/methodological_module/:id",
  practicalModule: "/practical_module/:id",
  additionalMaterials: "/additional_materials"
};


